import { render, staticRenderFns } from "./GrupoPorto.vue?vue&type=template&id=22892515"
import script from "./GrupoPorto.vue?vue&type=script&lang=js"
export * from "./GrupoPorto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports